import {
  Component,
  Input,
  ElementRef,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  OnDestroy,
  Renderer2,
  ViewChildren,
  AfterViewChecked,
  QueryList,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { SafeHtml } from '@angular/platform-browser';
import { ButtonComponent } from '../../../molecules/button/button.component';
import { ButtonType } from '../../../../shared/enums/button-type.enums';
import { LinkComponent } from '../../../atoms/link/link.component';
import { PodcastItems } from '../../../../shared/interfaces/podcast-item.interface';
import { ImageComponent } from '../../../atoms/image/image.component';
import ImageType from '../../../../shared/enums/image-type.enums';
import { Link } from '../../../../shared/interfaces/link.interface';
import LinkType from '../../../../shared/enums/link-type.enums';
import {
  CaasComponent,
  CaasPodcast,
} from '../../../../shared/interfaces/caas/caas.interface';
import { HrefType } from '../../../../shared/enums/href-type.enums';
import { PodcastService } from '../../../../services/podcast.service';
import { Subscription } from 'rxjs';
import { CaasRoutesService } from '../../../../services/caas-routes.service';
import { ImagesService } from '../../../../services/images.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CapitalizePipe } from '../../../capitalize.pipe';
import { BaseAccordionComponent } from '../base-accordion.component';
import { ErrorHandlerService } from '../../../../services/error-handler.service';
import { safeAssign } from '../../../../shared/utils/safe-assign.util';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'hdi-podcast',
  standalone: true,
  templateUrl: './podcast.component.html',
  styleUrls: ['./podcast.component.scss'],
  imports: [
    CommonModule,
    ButtonComponent,
    ImageComponent,
    LinkComponent,
    CapitalizePipe,
    NgxSkeletonLoaderModule,
  ],
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class PodcastComponent
  extends BaseAccordionComponent
  implements AfterViewInit, AfterViewChecked, OnChanges, OnDestroy
{
  // Implementation of abstract method from BaseAccordionComponent
  getItems(): PodcastItems[] {
    return this.PodcastItems;
  }

  trackById(index: number, item: PodcastItems): string | number {
    return item.id || index;
  }
  accordion: ButtonType = ButtonType.OPEN_CLOSE_SECONDARY;
  @Input() id?: string = '';
  @Input() caasData?: CaasPodcast | CaasComponent;
  @Input() PodcastItems: PodcastItems[] = [];
  @Input() type: ImageType = ImageType.IMAGE_100;
  @Input() link?: Link;
  @Input() linkHeadline?: string;
  @ViewChildren('podcastsRef') podcastsRef: QueryList<ElementRef> =
    new QueryList<ElementRef>();
  isPodcastHub = false;
  moreLessType = ButtonType.SECONDARY_ICON;
  visiblePodcasts = 5;
  podcastStep = 3;
  isUnrolledLabel = 'Mehr Podcasts anzeigen';
  isUnrolledIcon = 'plus';
  LinkType = LinkType;
  HrefType = HrefType;
  currentIframe?: string;
  safeIframe?: SafeHtml;
  currentIframes?: string[];
  safeIframes?: SafeHtml[];

  iframeSubscription?: Subscription;
  multipleIframeSubscription?: Subscription;

  public isLoading = true;

  constructor(
    private readonly podcastService: PodcastService,
    public readonly renderer: Renderer2,
    private readonly caasRoutesService: CaasRoutesService,
    private readonly imagesService: ImagesService,
    protected override router: Router,
    protected override route: ActivatedRoute,
    protected override cdr: ChangeDetectorRef,
    private readonly errorHandler: ErrorHandlerService,
    @Inject(PLATFORM_ID) private readonly platformId: object
  ) {
    super(cdr);
  }

  override ngAfterViewInit() {
    if (this.PodcastItems?.length && !this.caasData) {
      this.isOpen = this.PodcastItems.map(() => false);
    }
  }

  ngAfterViewChecked(): void {
    if (this.isPodcastHub) {
      this.setVisiblePodcasts();
    }
  }

  override ngOnChanges(changes: SimpleChanges): void {
    if (changes['caasData']) {
      this.caasData = changes['caasData'].currentValue;
      switch (
        (this.caasData as CaasPodcast)?.formData?.st_layout?.value?.identifier
      ) {
        case 'section':
          this.setCaasLink();
          this.filterCaasPodcast();
          this.setCaasOpenState(this.PodcastItems, 'section');
          break;
        case 'hub':
          this.PodcastItems = this.getPodcastBySerieId();
          this.isPodcastHub = this.PodcastItems.length > this.visiblePodcasts;
          this.setVisiblePodcasts();
          break;
      }
      if (isPlatformBrowser(this.platformId)) {
        this.isLoading = false;
      }
    }
  }

  unRollAcoordion(
    visiblePodcasts: number,
    podcastStep: number,
    index: number,
    podcastId: string
  ) {
    const topBarOffset = 104;
    const steps = Math.round((index - 1 - visiblePodcasts) / podcastStep);
    for (let i = 0; i <= steps; i++) {
      this.showMoreLess();
    }
    // Scrollen zum Accordion
    setTimeout(() => {
      const element = document.getElementById(podcastId);
      if (element) {
        if (typeof window !== 'undefined') {
          const topOffset =
            element.getBoundingClientRect().top + window.scrollY - topBarOffset;
          window.scrollTo({ top: topOffset, behavior: 'smooth' });
        }
      }
    }, 100);
  }

  setCaasLink() {
    let label = '';
    let href = '404';
    let title = '';
    safeAssign(
      () => {
        this.linkHeadline =
          (this.caasData as CaasPodcast)?.formData?.st_header?.value ?? '';
      },
      'Assigning linkHeadline',
      this.errorHandler
    );
    safeAssign(
      () => {
        label =
          (this.caasData as CaasPodcast)?.formData?.st_link?.value?.formData
            ?.lt_link_label?.value ?? '';
      },
      'Assign label',
      this.errorHandler
    );
    safeAssign(
      () => {
        href =
          this.caasRoutesService.getSeoRouteByIdentifier(
            this.caasData?.formData?.st_link?.value?.formData?.lt_link_internal
              ?.value?.identifier ?? '',
            this.router.config
          )?.path ?? '404';
      },
      'Assign href',
      this.errorHandler
    );
    safeAssign(
      () => {
        title =
          this.caasData?.formData?.st_link?.value?.formData?.lt_link_title
            ?.value ?? '';
      },
      'Assign title',
      this.errorHandler
    );
    this.link = {
      label: label,
      hrefType: HrefType.ANGULAR_ROUTE,
      href: href,
      title: title,
    };
  }

  filterCaasPodcast() {
    let podcastQuantity = 3;
    switch (
      (this.caasData as CaasPodcast)?.formData?.st_selection_type?.value
        ?.identifier
    ) {
      case 'automatic': {
        const podcastSeries = this.getPodcastBySerieId();
        switch (
          (this.caasData as CaasPodcast)?.formData?.st_quantity?.value
            ?.identifier
        ) {
          case '6':
            podcastQuantity = 6;
            this.PodcastItems = this.sortPodcastByDate(podcastSeries).slice(
              0,
              podcastQuantity
            );
            break;
          case '9':
            podcastQuantity = 9;
            this.PodcastItems = this.sortPodcastByDate(podcastSeries).slice(
              0,
              podcastQuantity
            );
            break;
          default:
            this.PodcastItems = this.sortPodcastByDate(podcastSeries).slice(
              0,
              podcastQuantity
            );
        }
        break;
      }
      case 'manual': {
        const hasPodcasts = this.handleWarning('no podcast found');
        if (!hasPodcasts) return;
        this.PodcastItems = this.podcastService.getManualSelectionPodcasts(
          (this.caasData as CaasPodcast)?.formData?.st_items?.value
        );
        break;
      }
    }
  }

  getPodcastBySerieId(): PodcastItems[] {
    if (
      (this.caasData as CaasPodcast)?.formData?.st_podcast?.value?.identifier
    ) {
      return this.podcastService.getPodcastItemsBySerieId(
        (this.caasData as CaasPodcast).formData.st_podcast.value.identifier
      );
    }
    return [];
  }

  sortPodcastByDate(podcastItems: PodcastItems[]): PodcastItems[] {
    return podcastItems.sort((a, b) => b.timestamp - a.timestamp);
  }

  handleWarning(message: string): boolean {
    if (
      (this.caasData as CaasPodcast)?.formData?.st_items?.value.length === 0
    ) {
      console.info(message);
      return false;
    }
    return true;
  }

  setVisiblePodcasts() {
    if (this.podcastsRef) {
      this.podcastsRef.forEach((podcast, index) => {
        if (index >= this.visiblePodcasts) {
          this.renderer.setStyle(podcast?.nativeElement, 'display', 'none');
        }
      });
    }
  }

  checkUnrolledState() {
    if (this.visiblePodcasts >= this.PodcastItems.length) {
      this.isUnrolledLabel = 'Weniger Podcasts anzeigen';
      this.isUnrolledIcon = 'minus';
    } else {
      this.isUnrolledLabel = 'Mehr Podcasts anzeigen';
      this.isUnrolledIcon = 'plus';
    }
  }

  showMoreLess() {
    if (this.visiblePodcasts < this.PodcastItems.length) {
      this.visiblePodcasts += this.podcastStep;
      if (this.podcastsRef) {
        this.podcastsRef.forEach((podcast, index) => {
          if (index < this.visiblePodcasts) {
            this.renderer.setStyle(podcast?.nativeElement, 'display', 'grid');
          }
        });
        this.checkUnrolledState();
      }
    } else {
      this.visiblePodcasts = 5;
      if (this.podcastsRef) {
        this.podcastsRef.forEach((podcast, index) => {
          if (index >= this.visiblePodcasts) {
            this.renderer.setStyle(podcast?.nativeElement, 'display', 'none');
          }
        });
      }
      this.checkUnrolledState();
    }
  }

  fetchSingleIframe(index: number) {
    if (this.PodcastItems?.length > 0) {
      const podcastUrl = this.PodcastItems[index]?.url;
      if (podcastUrl) {
        this.iframeSubscription = this.podcastService
          .getSinglePodcastIframe(podcastUrl)
          .subscribe((iframe: SafeHtml | null) => {
            if (iframe) {
              this.PodcastItems[index].safeIframe = iframe;
              this.safeIframe = iframe;
            } else {
              console.info('No iframe content received for index:', index);
            }
          });
      } else {
        console.info('Invalid podcast URL for index:', index);
      }
    }
  }

  fetchMultipleIframes(selectionType: 'automatic' | 'manual') {
    this.safeIframe = undefined;
    this.currentIframe = undefined;

    this.multipleIframeSubscription = this.podcastService
      .getMultiplePodcastIframes(this.PodcastItems)
      .subscribe({
        next: (podcastItems: PodcastItems[]) => {
          if (selectionType === 'automatic') {
            this.PodcastItems = this.sortPodcastByDate(podcastItems);
          } else {
            this.PodcastItems = podcastItems;
          }
        },
        error: (error) => {
          console.info('Error fetching iframes:', error);
        },
      });
  }

  handleClick(index: number) {
    this.toggleOpenClose(index);
    if (this.isOpen[index] && !this.PodcastItems[index].safeIframe) {
      this.fetchSingleIframe(index);
    }
  }

  getAltTextById(id: string): string | undefined {
    return this.imagesService.getAltTextById(id);
  }

  override ngOnDestroy(): void {
    this.iframeSubscription?.unsubscribe();
    this.multipleIframeSubscription?.unsubscribe();
  }
}
